import { Pipe, PipeTransform } from '@angular/core'
import { DatePipe } from '@angular/common'

@Pipe({ name: 'shortStr' })
export class ShortenStringPipe implements PipeTransform {
  transform(value: string, maxLen: number = 10): string {
    try {
      if (!value) {
        return ''
      } else {
        if (value?.length > 10) {
          return `${value.substr(0, 10)}...`
        } else {
          return value
        }
      }
    } catch (e) {
      return 'ERROR'
    }
  }
}
